import {
	CHAIN_STRATEGY_LABELS,
	CHAIN_STRATEGY_VALUES,
	CONVERGENCE_STRATEGY_LABELS,
	CONVERGENCE_STRATEGY_VALUES,
	COUNTDOWN_SECONDS_VALUES,
	ENDING_RARITY_META,
	ENDING_RARITY_VALUES,
	FLAG_CONDITION_CMP_VALUES,
	FLAG_EFFECT_OP_VALUES,
	FLAG_TYPE_VALUES,
	GENERATION_FAILURE_REASON_LABELS,
	GENERATION_FAILURE_REASON_VALUES,
	GENRE_LABELS,
	GENRE_VALUES,
	GOLDEN_ASSET_KIND_LABELS,
	NARRATIVE_MODE_LABELS,
	NARRATIVE_MODE_VALUES,
	PRODUCTION_STATE_LABELS,
	ProductionState,
	type ProductionState as ProductionStateType,
	RENDER_MODE_LABELS,
	RENDER_MODE_VALUES,
	StoryStatus,
	type StoryStatus as StoryStatusType,
	VISUAL_STYLE_LABELS,
	VISUAL_STYLE_VALUES,
} from "@storyline/shared";
import type { PillTone } from "@/src/common/components/pill";
import type { SelectOption } from "@/src/common/components/select-field";

export const STORY_STATUS_LABELS: Record<StoryStatusType, string> = {
	[StoryStatus.DRAFT]: "Brouillon",
	[StoryStatus.PUBLISHED]: "Publié",
	[StoryStatus.ARCHIVED]: "Archivé",
};

export const STORY_STATUS_TONES: Record<StoryStatusType, PillTone> = {
	[StoryStatus.DRAFT]: "neutral",
	[StoryStatus.PUBLISHED]: "success",
	[StoryStatus.ARCHIVED]: "warning",
};

export const PRODUCTION_STATE_TONES: Record<ProductionStateType, PillTone> = {
	[ProductionState.DRAFT]: "neutral",
	[ProductionState.STORY_REVIEW]: "neutral",
	[ProductionState.REFERENCES_REVIEW]: "accent",
	[ProductionState.KEYFRAMES_GENERATING]: "warning",
	[ProductionState.KEYFRAMES_REVIEW]: "accent",
	[ProductionState.VIDEOS_GENERATING]: "warning",
	[ProductionState.VIDEOS_REVIEW]: "accent",
	[ProductionState.READY]: "success",
};

export const GENRE_OPTIONS: SelectOption[] = GENRE_VALUES.map((value) => ({ value, label: GENRE_LABELS[value] }));

export const VISUAL_STYLE_OPTIONS: SelectOption[] = VISUAL_STYLE_VALUES.map((value) => ({ value, label: VISUAL_STYLE_LABELS[value] }));

export const NARRATIVE_MODE_OPTIONS: SelectOption[] = NARRATIVE_MODE_VALUES.map((value) => ({
	value,
	label: NARRATIVE_MODE_LABELS[value],
}));

export const RARITY_OPTIONS: SelectOption[] = ENDING_RARITY_VALUES.map((value) => ({ value, label: ENDING_RARITY_META[value].label }));

export const RENDER_MODE_OPTIONS: SelectOption[] = RENDER_MODE_VALUES.map((value) => ({ value, label: RENDER_MODE_LABELS[value] }));

export const CHAIN_STRATEGY_OPTIONS: SelectOption[] = CHAIN_STRATEGY_VALUES.map((value) => ({
	value,
	label: CHAIN_STRATEGY_LABELS[value],
}));

export const CONVERGENCE_OPTIONS: SelectOption[] = CONVERGENCE_STRATEGY_VALUES.map((value) => ({
	value,
	label: CONVERGENCE_STRATEGY_LABELS[value],
}));

export const COUNTDOWN_OPTIONS: SelectOption[] = COUNTDOWN_SECONDS_VALUES.map((value) => ({ value: String(value), label: `${value} s` }));

export const FAILURE_REASON_OPTIONS: SelectOption[] = GENERATION_FAILURE_REASON_VALUES.map((value) => ({
	value,
	label: GENERATION_FAILURE_REASON_LABELS[value],
}));

export const FLAG_TYPE_OPTIONS: SelectOption[] = FLAG_TYPE_VALUES.map((value) => ({ value, label: value }));

export const FLAG_OP_OPTIONS: SelectOption[] = FLAG_EFFECT_OP_VALUES.map((value) => ({ value, label: value }));

export const FLAG_CMP_OPTIONS: SelectOption[] = FLAG_CONDITION_CMP_VALUES.map((value) => ({ value, label: value }));

export { GOLDEN_ASSET_KIND_LABELS, PRODUCTION_STATE_LABELS };
